/** One colour pair that fails the contrast guard rail: which mode, which pair, the ratio it has and the one it needs. */
export interface ContrastProblem {
  mode: 'light' | 'dark' | 'pass';
  /** The pair's id, e.g. "text-on-bg". */
  pair: string;
  /** In words, e.g. "Body text on the page background". */
  label: string;
  fg: string;
  bg: string;
  ratio: number;
  needs: number;
}

/** A rule of the app's look broken (docs/26): a reason people can act on, a stable code, and for colours every failing pair. */
export class AppearanceError extends Error {
  override name = 'AppearanceError';
  constructor(message: string, public readonly code: string = 'bad_appearance', public readonly problems?: ContrastProblem[]) {
    super(message);
  }
}
